module.exports = __webpack_public_path__ + "img/txt_info3.6c1790cb.png";